import React from "react";
import { STEPS } from "../../mock";
import Reveal from "./Reveal";

const HowItWorks = () => (
  <section id="how" className="relative overflow-hidden py-24 sm:py-28">
    <div className="pointer-events-none absolute inset-0 bg-grid opacity-40" />
    <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-sm font-semibold uppercase tracking-wider text-primary">How it works</span>
          <h2 className="mt-3 font-display text-3xl font-bold tracking-tight text-foreground sm:text-4xl">
            From plain-language goal to verified result
          </h2>
        </div>
      </Reveal>

      <div className="mt-16 space-y-16">
        {STEPS.map((s, i) => (
          <Reveal key={s.n} delay={i * 60}>
            <div className={`grid items-center gap-8 lg:grid-cols-2 ${i % 2 === 1 ? "lg:[&>div:first-child]:order-2" : ""}`}>
              <div>
                <span className="font-display text-5xl font-bold text-primary/20">{s.n}</span>
                <h3 className="mt-2 font-display text-2xl font-semibold text-foreground">{s.title}</h3>
                <p className="mt-3 max-w-md text-lg leading-relaxed text-muted-foreground">{s.desc}</p>
              </div>
              <div className="relative overflow-hidden rounded-2xl border border-border bg-card shadow-lg">
                <img src={s.img} alt={s.title} className="aspect-[16/10] w-full object-cover" loading="lazy" />
                <div className="absolute inset-0 ring-1 ring-inset ring-black/5" />
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default HowItWorks;
